import React, { lazy } from 'react';
import { GoldButton } from './GoldButton';
import { motion } from 'framer-motion';
interface FinalCTAProps {
  onRegisterClick: () => void;
}
export function FinalCTA({
  onRegisterClick
}: FinalCTAProps) {
  return <section className="py-20 md:py-32 bg-brand-blue" data-id="element-57">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-58">
        <div className="bg-brand-navy border border-brand-gold/40 rounded-3xl px-4 py-12 md:px-6 md:py-16 shadow-2xl flex flex-col items-center gap-12 md:gap-16" data-id="element-59">
          {/* Headline + CTA (centered, top) */}
          <div className="text-center max-w-4xl px-4" data-id="element-60">
            <h2 className="font-display text-white text-4xl md:text-6xl lg:text-7xl font-bold uppercase leading-tight mb-10" data-id="element-61">
              Your Next{' '}
              <span className="relative inline-block" data-id="element-62">
                6 To 7 Figure
                <div className="absolute -bottom-2 left-0 w-full h-2 bg-brand-gold" data-id="element-63"></div>
              </span>{' '}
              Payday In 90 Days!
            </h2>

            <div className="flex justify-center w-full" data-id="element-64">
              <GoldButton onClick={onRegisterClick} mainText="Secure Ticket Now" subText="(SEE YOU IN THE CHALLENGE)" className="w-full md:w-auto md:min-w-[320px]" data-id="element-65" />
            </div>
          </div>

          {/* Ticket (below, full width) */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full flex justify-center relative" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/4Th71gXyqrb1WuF4ri9Dzz/69fa843ad38dd618871a08f8.png" alt="Fast Profit — The 90-Minute CRE Workshop ticket. Scan QR code to register." className="w-full h-auto block rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.5)]" style={{
            maxWidth: '900px',
            objectFit: 'contain'
          }} loading="lazy" decoding="async" data-id="element-67" />

            {/* Soft gold glow behind ticket */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] bg-brand-gold/10 rounded-full blur-3xl -z-10" data-id="element-68"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}